import { render, staticRenderFns } from "./newpage5.vue?vue&type=template&id=4ed85f82&scoped=true&"
import script from "./newpage5.vue?vue&type=script&lang=js&"
export * from "./newpage5.vue?vue&type=script&lang=js&"
import style0 from "./newpage5.vue?vue&type=style&index=0&id=4ed85f82&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed85f82",
  null
  
)

export default component.exports